// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchUI_wrapper__2pzP5","title":"SearchUI_title__v7SA2","sub_title":"SearchUI_sub_title__k9FZw","mobile":"SearchUI_mobile__1RCfm"};